import { render, staticRenderFns } from "./LandingForClients.vue?vue&type=template&id=0090a2d4&scoped=true&lang=pug"
import script from "./LandingForClients.vue?vue&type=script&lang=js"
export * from "./LandingForClients.vue?vue&type=script&lang=js"
import style0 from "./LandingForClients.vue?vue&type=style&index=0&id=0090a2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090a2d4",
  null
  
)

export default component.exports